// Angular Files
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// Payment Integrations
import { PaymentProcessorProvider } from 'apps/public-portal/src/app/payment-integrations';

// Teller Online Files
import {
    AuthService,
    UserService,
    InboundRedirectService
} from 'apps/public-portal/src/app/core/services';

// Teller Online Library Files
import {
    TellerOnlineAppService,
    TellerOnlineSiteMetadataService
} from 'teller-online-libraries/core';

@Component({
    selector: 'app-header',
    template: `
        <public-header
            [preview]="false"
            [siteTitle]="siteTitle"
            [helpOpened]="helpOpened"
            [appService]="appService"
            [siteMetadataService]="siteMetadataService"
            [authService]="authService"
            [userService]="userService"
            [paymentProvider]="paymentProvider"
            [inboundRedirectService]="inboundRedirectService"
            [authenticationEnabled]="siteMetadataService?.authenticationEnabled"
            [isCheckoutSuccessPage]="isCheckoutSuccessPage"
            [returnToSenderLabel]="returnToSenderLabel"
            (toggleMobileMenu)="toggleMobileMenu.emit($event)"
            (toggleHelp)="toggleHelp.emit($event)">
        </public-header>
    `,
    host: {
        class: 'header'
    }
})
export class HeaderComponent {
    @Output() toggleMobileMenu = new EventEmitter<boolean>();
    @Output() toggleHelp = new EventEmitter<boolean>();
    @Input() siteTitle: string;
    @Input() helpOpened: boolean = false;

    public returnToSenderLabel: string = "Cancel Payment";
    public isCheckoutSuccessPage: boolean = false;

    constructor(
        public appService: TellerOnlineAppService,
        public siteMetadataService: TellerOnlineSiteMetadataService,
        public authService: AuthService,
        public userService: UserService,
        public paymentProvider: PaymentProcessorProvider,
        public inboundRedirectService: InboundRedirectService,
        public router: Router
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isCheckoutSuccessPage = event.url.includes('/checkout/success');
                this.returnToSenderLabel = this.isCheckoutSuccessPage
                    ? `Return to ${inboundRedirectService.redirectSourceFriendlyName}`
                    : 'Cancel Payment';
            }
        });
    }
}

